export { default } from './Divider';

export { default as dividerClasses } from './dividerClasses';
export * from './dividerClasses';
